<div class="sub-modal-header">
  <button type="button" class="btn-close-custom" (click)="activeModal.dismiss()">&#x2715;</button>
  <div class="header-icon">
    <i class="las la-lock"></i>
  </div>
  <h4>Safecloud <span class="pro-text">Pro</span></h4>
  <p>Desbloquea el análisis inteligente de datos sensibles</p>
</div>

<div class="sub-modal-body">
  <div class="features-list">
    <div class="feature-item"><i class="las la-check-circle"></i> Análisis IA de alertas DLP</div>
    <div class="feature-item"><i class="las la-check-circle"></i> Detección de anomalías y patrones de riesgo</div>
    <div class="feature-item"><i class="las la-check-circle"></i> Recomendaciones personalizadas por usuario</div>
    <div class="feature-item"><i class="las la-check-circle"></i> Análisis de datos personales, financieros y de salud</div>
  </div>

  <div class="form-section">
    <p class="form-title">Para comenzar, ingresá tus datos:</p>

    <div class="form-group mb-3">
      <label class="form-label">Nombre <span class="required">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="nombre"
        [class.is-invalid]="submitted && !nombre.trim()"
        placeholder="Tu nombre"
        autocomplete="given-name"
      />
      <div class="invalid-feedback">El nombre es requerido</div>
    </div>

    <div class="form-group mb-4">
      <label class="form-label">Apellido <span class="required">*</span></label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="apellido"
        [class.is-invalid]="submitted && !apellido.trim()"
        placeholder="Tu apellido"
        autocomplete="family-name"
      />
      <div class="invalid-feedback">El apellido es requerido</div>
    </div>

    <button type="button" class="btn btn-activate w-100" (click)="submit()">
      <i class="las la-rocket"></i>
      Activar Safecloud Pro
    </button>

    <button type="button" class="cancel-link" (click)="activeModal.dismiss()">
      Cancelar
    </button>
  </div>
</div>
